import React from 'react'
import { Dialog, DialogContent, CircularProgress } from '@mui/material'
import CircularProgressWithLabel from './CircularProgressWithLabel'

const DialogLoading = ({ loadingCSV }) => {
  return (
    <div>
      <Dialog open={true}>
        <DialogContent>
          <CircularProgress color="primary" />
          <CircularProgressWithLabel value={loadingCSV} />
          <p>Carregando...</p>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default DialogLoading
